import { render } from "./CreatePostModal.vue?vue&type=template&id=3b309444"
import script from "./CreatePostModal.vue?vue&type=script&lang=js"
export * from "./CreatePostModal.vue?vue&type=script&lang=js"

import "./CreatePostModal.vue?vue&type=style&index=0&id=3b309444&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__